import { useState, useEffect } from "react";
import { ExpandedContent, Separator, TableContainer } from "./styles";
import { IItemHistorico } from "../../../../types";
import api from "../../../../../../../services/api";
import LogsVazio from "../../Compartilhado/LogsVazio";
import { getStatusLabelDemanda } from "../../../../../../../utility/statusDemanda";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

interface CampoAlterado {
    campo: string;
    antes: any;
    depois: any;
}

const formatValue = (value: any): string => {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
};

const compararDados = (dadosAntes: any, dadosDepois: any): CampoAlterado[] => {
    const campos: CampoAlterado[] = [];

    if (dadosDepois?.status && dadosAntes?.status !== dadosDepois.status) {
        campos.push({
            campo: 'Status',
            antes: getStatusLabelDemanda(dadosAntes?.status || 'Em Triagem'),
            depois: getStatusLabelDemanda(dadosDepois.status)
        });
    }

    if (dadosDepois?.prazo_aceite && dadosAntes?.prazo_aceite !== dadosDepois.prazo_aceite) {
        campos.push({
            campo: 'Prazo de aceite',
            antes: formatValue(dadosAntes?.prazo_aceite),
            depois: formatValue(dadosDepois.prazo_aceite)
        });
    }

    return campos;
};

export default function ExpandedContentContratacaoIniciada({ 
    item, 
    onNavigateToFile 
}: ExpandedContentProps) {
    const [camposPrincipal, setCamposPrincipal] = useState<CampoAlterado[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!item.id) {
            setLoading(false);
            return;
        }

        const buscarDados = async () => {
            try {
                setLoading(true);
                const response = await api.get(`log-historico/${item.id}`);

                if (response.data.status === 'success') {
                    const logs = response.data.result || [];
                    const logProposta = logs.find((log: any) => log.entidade_nome === 'proposta');

                    if (logProposta) {
                        let dadosAntes = logProposta.dados_antes;
                        let dadosDepois = logProposta.dados_depois;

                        if (typeof dadosAntes === 'string') {
                            try {
                                dadosAntes = JSON.parse(dadosAntes);
                            } catch (e) {
                                console.error('Erro ao fazer parse de dados_antes:', e);
                            }
                        }

                        if (typeof dadosDepois === 'string') {
                            try {
                                dadosDepois = JSON.parse(dadosDepois);
                            } catch (e) {
                                console.error('Erro ao fazer parse de dados_depois:', e);
                            }
                        }

                        const campos = compararDados(dadosAntes, dadosDepois);
                        setCamposPrincipal(campos);
                    } else {
                        setCamposPrincipal([]);
                    }
                } else {
                    setCamposPrincipal([]);
                }
            } catch (error: any) {
                console.error('Erro ao buscar dados do histórico:', error);
                setCamposPrincipal([]);
            } finally {
                setLoading(false);
            }
        };

        buscarDados();
    }, [item.id]);

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--c64748b)' }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (camposPrincipal.length === 0) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            <div className="expanded-section">
                <h4 className="section-title">Principal</h4>
                <TableContainer>
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th className="field-col">Campo</th>
                                <th className="before-col">Antes</th>
                                <th className="after-col">Depois</th>
                            </tr>
                        </thead>
                        <tbody>
                            {camposPrincipal.map((campo, index) => (
                                <tr key={campo.campo} className={index > 0 ? 'border-top' : ''}>
                                    <td className="field-cell">{campo.campo}</td>
                                    <td className="before-cell">{formatValue(campo.antes)}</td>
                                    <td className="after-cell">
                                        <div className="after-content">
                                            <span className="highlight-bar" />
                                            <span>{formatValue(campo.depois)}</span>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableContainer>
            </div>
        </ExpandedContent>
    );
}

